import { z } from 'zod';
export const MEDIA_TYPES = ['movie', 'tv'];
export const mediaTypeSchema = z.enum(MEDIA_TYPES);
export const MEDIA_TYPE_LABELS = {
    movie: 'Фильм',
    tv: 'Сериал',
};
//# sourceMappingURL=media-type.js.map